@if (showMessage) {
<div class="system-message">
    <span style="grid-area: page-number;">
        <span class="ups-icon ups-icon-chevron-left"></span>
        <span class="message-number">{{localize(langSection.SystemMessage,
            langText.OneOfOne)}}</span>
        <span class="ups-icon ups-icon-chevron-right"></span>
    </span>
    <span class="message" style="grid-area: message;">
        {{localize(langSection.SystemMessage, langText.DownForMaintenance)}}
    </span>
    <span role="button" class="ups-icon ups-icon-x" style="grid-area: close;" (click)="closeMessage()"></span>
</div>
}